import { Longhand } from "../longhand.js";
import Base from "./top.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/right}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=right.js.map